import { useState } from "react";
import { primaryColor } from "../../../utils/comon";

const SectionTab = ({ tabs, defaultTab, activeTab: propActiveTab, onTabChange }) => {
  const [internalActiveTab, setInternalActiveTab] = useState(defaultTab || tabs[0].key);

  const activeTab = propActiveTab !== undefined ? propActiveTab : internalActiveTab;

  const handleTabChange = (key) => {
    if (onTabChange) onTabChange(key);
    setInternalActiveTab(key);
  };

  const ActiveComponent = tabs.find(tab => tab.key === activeTab)?.component;

  return (
    <>

      {/* Tab Header */}
      <div className="mt-2 border-b border-slate-200 dark:border-bordercolor flex gap-6">

        {tabs.map((tab) => {

          const isActive = activeTab === tab.key;

          return (
            <button
              key={tab.key}
              onClick={() => handleTabChange(tab.key)}
              className={`pb-3 text-xs font-medium transition whitespace-nowrap
                ${!isActive ? "text-[#64748B] dark:text-textsecondary" : "border-b-2"}
              `}
              style={
                isActive
                  ? {
                    color: primaryColor(),
                    borderColor: primaryColor(),
                  }
                  : {}
              }
            >
              {tab.label}
            </button>
          );

        })}

      </div>

      {/* Tab Content */}
      <div className="flex-1  pt-4 scrollbar-hide">

        {ActiveComponent && <ActiveComponent />}

      </div>

    </>
  );
};

export default SectionTab;